import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreSelectionDrawer, {
    attrs: {
      "is-checked-variant": "",
      "has-footer": !!_setup.diseases.length,
      "has-search": !!_setup.diseases.length,
      title: _vm.title,
      "title-truncate": _vm.titleTruncate,
      placeholder: _vm.placeholder,
      "is-back": _vm.isBack,
      value: _vm.value,
      items: _setup.diseases,
      "selected-item": _vm.selectedDisease,
      loading: _setup.loading,
      error: _setup.error,
      attach: ".vue-the-doctors-filters .v-application",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", false)
      },
      back: function ($event) {
        return _vm.$emit("input", false)
      },
      "click-item": _setup.handleClickDisease,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "append-header",
          fn: function () {
            return [
              _vm.selectedDisease
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-auto",
                      attrs: { color: "primary", small: "", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("disease:reset")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.t("Сбросить", _setup.options)) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        !_setup.diseases.length
          ? {
              key: "empty-list",
              fn: function () {
                return [
                  _c("div", { staticClass: "py-16 px-10 my-9 text-center" }, [
                    _c("div", { staticClass: "text-h6 text--text mb-2" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t("Ничего не нашлось", _setup.options)
                          ) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-body-1 text-secondary--text" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.t("У врачей", _setup.options)) +
                            "\n        "
                        ),
                        _setup.townId
                          ? [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _setup.t("вашего города", _setup.options)
                                  ) +
                                  "\n        "
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _setup.t(
                                "не заполнены эти данные",
                                _setup.options
                              )
                            ) +
                            "\n      "
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "footer",
          fn: function () {
            return [
              _vm._t("footer", null, null, {
                selectedDisease: _vm.selectedDisease,
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }